import {Directive} from '@angular/core';

@Directive({selector: 'app-page-title-actions'})
export class PageTitleDirective {
}

